import React from 'react';
import { Bell, CheckCircle2, AlertCircle } from 'lucide-react';
import { THEMES } from '../config/constants';

const AlertsView = ({ alerts, currentUser, theme, onClearAlerts }) => {
    const myVisibleAlerts = alerts.filter(a => !(a.clearedBy || []).includes(currentUser.id));

    return (
        <div className="p-8 space-y-8 animate-in fade-in duration-500">
            <div className="flex flex-col md:flex-row justify-between md:items-center gap-4">
                <h2 className={`text-4xl font-black ${THEMES[theme].heading} flex items-center gap-3`}>
                    <Bell size={36} />
                    Alerts Center
                </h2>
                {myVisibleAlerts.length > 0 && (
                    <button 
                        onClick={onClearAlerts} 
                        className="text-sm bg-red-100 text-red-600 hover:bg-red-200 px-4 py-2 rounded-xl font-bold transition-colors shadow-sm"
                    >
                        Clear All Notifications
                    </button>
                )}
            </div>

            <div className={`p-6 rounded-[2rem] border bg-white/30 backdrop-blur-xl ${theme === 'dark' ? 'border-slate-800' : 'border-white/50'}`}>
                <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
                    {myVisibleAlerts.length === 0 ? (
                        <div className="py-24 text-center flex flex-col items-center justify-center opacity-40">
                            <CheckCircle2 size={64} className={THEMES[theme].textMuted} strokeWidth={1} />
                            <p className={`mt-4 font-bold ${THEMES[theme].textMuted}`}>You're all caught up!</p>
                            <p className={`text-sm ${THEMES[theme].textMuted}`}>No new alerts found.</p>
                        </div>
                    ) : (
                        myVisibleAlerts.map((alert, idx) => {
                            const isQuoteAlert = alert.type === 'quote_generated';
                            const bgColor = isQuoteAlert ? 'bg-green-50 border-green-100' : 'bg-red-50 border-red-100';
                            const textColor = isQuoteAlert ? 'text-green-700' : 'text-red-700';
                            const timeColor = isQuoteAlert ? 'text-green-500' : 'text-red-400';
                            const title = isQuoteAlert ? 'New Quotation / Proforma Invoice Generated' : 'Below Minimum Price Attempt';

                            return (
                                <div key={alert.id || idx} className={`p-5 ${bgColor} border rounded-2xl flex flex-col gap-3 relative shadow-sm transition-all hover:shadow-md`}>
                                    <p className={`text-xs ${timeColor} absolute top-5 right-5 font-bold`}>{new Date(alert.timestamp).toLocaleString()}</p>
                                    <h4 className={`font-black ${textColor} text-base flex items-center gap-2`}>
                                        {isQuoteAlert ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}
                                        {title}
                                    </h4>
                                    
                                    {isQuoteAlert ? (
                                        <div className={`text-sm ${textColor} opacity-80 font-medium`}>
                                            <p><strong>{alert.userName}</strong> generated a new document for <strong>{alert.customerName}</strong>.</p>
                                            <p className="mt-1">Quote ID: <strong>{alert.quoteId}</strong> | Total: <strong>{alert.totalAmount}</strong></p>
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-1">
                                            <div><span className={`block text-[10px] font-black uppercase tracking-wider ${textColor} opacity-60 mb-0.5`}>Customer</span><span className={`text-sm font-bold ${textColor}`}>{alert.customerName}</span></div>
                                            <div><span className={`block text-[10px] font-black uppercase tracking-wider ${textColor} opacity-60 mb-0.5`}>User</span><span className={`text-sm font-bold ${textColor}`}>{alert.userName}</span></div>
                                            <div><span className={`block text-[10px] font-black uppercase tracking-wider ${textColor} opacity-60 mb-0.5`}>Set Price</span><span className={`text-sm font-bold ${textColor}`}>{alert.setPrice}</span></div>
                                            <div><span className={`block text-[10px] font-black uppercase tracking-wider ${textColor} opacity-60 mb-0.5`}>Quoted Price</span><span className={`text-sm font-bold text-red-600`}>{alert.givenPrice}</span></div>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default AlertsView;
